module.exports = __webpack_public_path__ + "img/xwzx.55b5fe16.png";